import React from "react";

export const tableConfigDetailKSU = {
    withQR: [
        {
            name: "",
            label: "No",
            options: {
                customBodyRender: (_, tableMeta) => {
                    const {page, rowsPerPage} = tableMeta.tableState;
                    const rowNumber = page * rowsPerPage + tableMeta.rowIndex + 1;

                    return <>{rowNumber}</>;
                },
            },
        },
        {
            name: "dataMasterKSU",
            label: "Kode KSU",
            options: {
                customBodyRender: (value) => {
                    return value ? value.kodeKSU : "-";
                },
                sort: false,
            },
        },
        {
            name: "dataMasterKSU",
            label: "Nama KSU",
            options: {
                customBodyRender: (value) => {
                    return value ? value.name : "-";
                },
                sort: false,
            },
        },
        {
            name: "dataMasterKSU",
            label: "Group KSU",
            options: {
                customBodyRender: (value) => {
                    return value ? value.categoryDTO?.value : "-";
                },
                sort: false,
            },
        },
        {
            name: "",
            label: "Qty",
            options: {
                customBodyRender: (value) => {
                    return 1;
                },
                sort: false,
            },
        },
        {
            name: "dataMasterKSU",
            label: "Satuan",
            options: {
                customBodyRender: (value) => {
                    return value ? value.satuanDTO?.value : "-";
                },
                sort: false,
            },
        },
        {
            name: "ksuBarcode",
            label: "QR Code",
            options: {
                sort: false,
            },
        },
    ],
    withoutQR: [
        {
            name: "",
            label: "No",
            options: {
                customBodyRender: (_, tableMeta) => {
                    const {page, rowsPerPage} = tableMeta.tableState;
                    const rowNumber = page * rowsPerPage + tableMeta.rowIndex + 1;

                    return <>{rowNumber}</>;
                },
            },
        },
        {
            name: "kodeKSU",
            label: "Kode KSU",
            options: {
                sort: false,
            },
        },
        {
            name: "namaKSU",
            label: "Nama KSU",
            options: {
                sort: false,
            },
        },
        {
            name: "groupKSU",
            label: "Group KSU",
            options: {
                sort: false,
            },
        },
        {
            name: "qty",
            label: "Qty",
            options: {
                sort: false,
            },
        },
        {
            name: "satuan",
            label: "Satuan",
            options: {
                sort: false,
            },
        },
        {
            name: "actQTY",
            label: "Act Qty",
            options: {
                sort: false,
            },
        },
        {
            name: "diffQty",
            label: "Diff Qty",
            options: {
                sort: false,
            },
        },
        {
            name: "keterangan",
            label: "Keterangan",
            options: {
                sort: false,
            },
        },
        {
            name: "aksi",
            label: "Aksi",
            options: {
                sort: false,
            },
        },
    ]
}

export const tableConfigKSUReportSO = {
    withQR: [
        {
            name: "",
            label: "No",
            options: {
                customBodyRender: (_, tableMeta) => {
                    const {page, rowsPerPage} = tableMeta.tableState;
                    const rowNumber = page * rowsPerPage + tableMeta.rowIndex + 1;

                    return <>{rowNumber}</>;
                },
            },
        },
        {
            name: "dataMasterKSU",
            label: "Kode KSU",
            options: {
                customBodyRender: (value) => {
                    return value ? value.kodeKSU : "-";
                },
                sort: false,
            },
        },
        {
            name: "dataMasterKSU",
            label: "Nama KSU",
            options: {
                customBodyRender: (value) => {
                    return value ? value.name : "-";
                },
                sort: false,
            },
        },
        {
            name: "dataMasterKSU",
            label: "Kategori",
            options: {
                customBodyRender: (value) => {
                    return value ? value.categoryDTO?.value : "-";
                },
                sort: false,
            },
        },
        {
            name: "",
            label: "Qty",
            options: {
                customBodyRender: (value) => {
                    return 1;
                },
                sort: false,
            },
        },
        {
            name: "dataMasterKSU",
            label: "Satuan",
            options: {
                customBodyRender: (value) => {
                    return value ? value.satuanDTO?.value : "-";
                },
                sort: false,
            },
        },
        {
            name: "ksuBarcode",
            label: "QR Code",
            options: {
                sort: false,
            },
        },
        {
            name: "ksuExist",
            label: "Status",
            options: {
                customBodyRender: (value) => {
                    return value ? "DITEMUKAN" : "TIDAK DITEMUKAN";
                },
                sort: false,
            }
        },
        {
            name: "userId",
            label: "User",
            options: {
                sort: false,
            },
        },
    ],
    withoutQR: [
        {
            name: "",
            label: "No",
            options: {
                customBodyRender: (_, tableMeta) => {
                    const {page, rowsPerPage} = tableMeta.tableState;
                    const rowNumber = page * rowsPerPage + tableMeta.rowIndex + 1;

                    return <>{rowNumber}</>;
                },
            },
        },
        {
            name: "dataMasterKSU",
            label: "Kode KSU",
            options: {
                customBodyRender: (value) => {
                    return value ? value.kodeKSU : "-";
                },
                sort: false,
            },
        },
        {
            name: "dataMasterKSU",
            label: "Nama KSU",
            options: {
                customBodyRender: (value) => {
                    return value ? value.name : "-";
                },
                sort: false,
            },
        },
        {
            name: "dataMasterKSU",
            label: "Kategori",
            options: {
                customBodyRender: (value) => {
                    return value ? value.categoryDTO?.value : "-";
                },
                sort: false,
            },
        },
        {
            name: "",
            label: "Qty",
            options: {
                customBodyRender: (value) => {
                    return 1;
                },
                sort: false,
            },
        },
        {
            name: "dataMasterKSU",
            label: "Satuan",
            options: {
                customBodyRender: (value) => {
                    return value ? value.satuanDTO?.value : "-";
                },
                sort: false,
            },
        },
    ]
}

export const tableConfigKSUKelebihan = [
    {
        name: "",
        label: "No",
        options: {
            customBodyRender: (_, tableMeta) => {
                const {page, rowsPerPage} = tableMeta.tableState;
                const rowNumber = page * rowsPerPage + tableMeta.rowIndex + 1;

                return <>{rowNumber}</>;
            },
        },
    },
    {
        name: "dataMasterKSU",
        label: "Kode KSU",
        options: {
            customBodyRender: (value) => {
                return value ? value.kodeKSU : "-";
            },
            sort: false,
        },
    },
    {
        name: "dataMasterKSU",
        label: "Nama KSU",
        options: {
            customBodyRender: (value) => {
                return value ? value.name : "-";
            },
            sort: false,
        },
    },
    {
        name: "dataMasterKSU",
        label: "Kategori",
        options: {
            customBodyRender: (value) => {
                return value ? value.categoryDTO?.value : "-";
            },
            sort: false,
        },
    },
    {
        name: "",
        label: "Qty",
        options: {
            customBodyRender: (value) => {
                return 1;
            },
            sort: false,
        },
    },
    {
        name: "dataMasterKSU",
        label: "Satuan",
        options: {
            customBodyRender: (value) => {
                return value ? value.satuanDTO?.value : "-";
            },
            sort: false,
        },
    },
]

export const tableConfigKSUKekurangan = {
    withQR: [
        {
            name: "",
            label: "No",
            options: {
                customBodyRender: (_, tableMeta) => {
                    const {page, rowsPerPage} = tableMeta.tableState;
                    const rowNumber = page * rowsPerPage + tableMeta.rowIndex + 1;

                    return <>{rowNumber}</>;
                },
            },
        },
        {
            name: "dataMasterKSU",
            label: "Kode KSU",
            options: {
                customBodyRender: (value) => {
                    return value ? value.kodeKSU : "-";
                },
                sort: false,
            },
        },
        {
            name: "dataMasterKSU",
            label: "Nama KSU",
            options: {
                customBodyRender: (value) => {
                    return value ? value.name : "-";
                },
                sort: false,
            },
        },
        {
            name: "dataMasterKSU",
            label: "Kategori",
            options: {
                customBodyRender: (value) => {
                    return value ? value.categoryDTO?.value : "-";
                },
                sort: false,
            },
        },
        {
            name: "",
            label: "Qty",
            options: {
                customBodyRender: (value) => {
                    return 1;
                },
                sort: false,
            },
        },
        {
            name: "dataMasterKSU",
            label: "Satuan",
            options: {
                customBodyRender: (value) => {
                    return value ? value.satuanDTO?.value : "-";
                },
                sort: false,
            },
        },
        {
            name: "ksuBarcode",
            label: "QR Code",
            options: {
                sort: false,
            }
        },
    ],
    withoutQR: [
        {
            name: "",
            label: "No",
            options: {
                customBodyRender: (_, tableMeta) => {
                    const {page, rowsPerPage} = tableMeta.tableState;
                    const rowNumber = page * rowsPerPage + tableMeta.rowIndex + 1;

                    return <>{rowNumber}</>;
                },
            },
        },
        {
            name: "dataMasterKSU",
            label: "Kode KSU",
            options: {
                customBodyRender: (value) => {
                    return value ? value.kodeKSU : "-";
                },
                sort: false,
            },
        },
        {
            name: "dataMasterKSU",
            label: "Nama KSU",
            options: {
                customBodyRender: (value) => {
                    return value ? value.name : "-";
                },
                sort: false,
            },
        },
        {
            name: "dataMasterKSU",
            label: "Kategori",
            options: {
                customBodyRender: (value) => {
                    return value ? value.categoryDTO?.value : "-";
                },
                sort: false,
            },
        },
        {
            name: "",
            label: "Qty",
            options: {
                customBodyRender: (value) => {
                    return 1;
                },
                sort: false,
            },
        },
        {
            name: "dataMasterKSU",
            label: "Satuan",
            options: {
                customBodyRender: (value) => {
                    return value ? value.satuanDTO?.value : "-";
                },
                sort: false,
            },
        },
        {
            name: "ksuBarcode",
            label: "QR Code",
            options: {
                sort: false,
            }
        },
    ],
}